var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accounting-mutation',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isSaving = ref.isSaving;
var syncBillToProvider = ref.syncBillToProvider;
var deleteBill = ref.deleteBill;
return [_c('finance-tracker-document-popover',{attrs:{"documents":_vm.bills,"fn-delete":deleteBill,"fn-sync":syncBillToProvider},on:{"change":function($event){return _vm.$emit('change')}}},[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }